import React, {createContext, useCallback, useContext, useState} from 'react';
import {isEqual, isFunction} from "lodash";
import {initialFilter} from "./InvoicesUIHelpers";

const InvoicesUIContext = createContext();

export function useInvoicesUIContext() {
    return useContext(InvoicesUIContext);
}

export function InvoicesUIProvider({invoicesUIEvents, children}) {

    const [queryParams, setQueryParamsBase] = useState(initialFilter);
    const [ids, setIds] = useState([]);
    const setQueryParams = useCallback(nextQueryParams => {
        setQueryParamsBase(prevQueryParams => {
            if (isFunction(nextQueryParams)) {
                nextQueryParams = nextQueryParams(prevQueryParams);
            }

            if (isEqual(prevQueryParams, nextQueryParams)) {
                return prevQueryParams;
            }

            return nextQueryParams;
        });
    }, []);
    

    const value = {
        queryParams,
        setQueryParamsBase,
        setQueryParams,
        ids,
        setIds,
        newInvoiceButtonClick: invoicesUIEvents.newInvoiceButtonClick,
        viewInvoiceButtonClick: invoicesUIEvents.viewInvoiceButtonClick,
        deleteInvoiceButtonClick: invoicesUIEvents.deleteInvoiceButtonClick
    }

    return <InvoicesUIContext.Provider value={value}>{children}</InvoicesUIContext.Provider>

}